export enum FeaturedListContextType {
  SELECTION_RECIPIENT_LIST = "SELECTION_RECIPIENT_LIST",
  EXHIBITOR_LIST = "EXHIBITOR_LIST",
  SPONSOR_LIST = "SPONSOR_LIST"
}
